// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"311":"css/admin-app.6910","2323":"css/app.6910"}[chunkId] + ".css";
};